import ProposalState from "./ProposalState";

export const DisplayGigsState = [ProposalState.NEW_GIG, ProposalState.OPEN_BID];
